module.exports = __webpack_public_path__ + "static/media/Footbal_Ball_Legs_Knee_highs_5_A2_Rectangle_49_pattern@2x.450a0ee8.png";